/* src/app/web-scraping/web-scraping.component.scss */
.frame-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 50px;
  gap: 10px;
}
.iframe-div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.pure-pusher {
  height: 100%;
  width: 100%;
  display: flex;
}
/*# sourceMappingURL=web-scraping.component.css.map */
